import React, { useMemo } from "react";

import { buildMonthlySnapshots } from "./detailed-progress-utils";

const ProgressMonthlySection = ({ measurements = [] }) => {
  const snapshot = useMemo(
    () => buildMonthlySnapshots(measurements),
    [measurements]
  );

  if (snapshot.rows.length === 0 || snapshot.months.length === 0) {
    return (
      <section className="anthropometry-detailed-progress__card anthropometry-detailed-progress__card--monthly">
        <div className="anthropometry-detailed-progress__card__header">
          <div>
            <h2>Evolução mês a mês</h2>
            <p>Valores consolidados por mês calendário</p>
          </div>
        </div>
        <div className="anthropometry-detailed-progress__panel-empty">
          <p>Não há visitas suficientes para montar a evolução mensal neste período.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="anthropometry-detailed-progress__card anthropometry-detailed-progress__card--monthly">
      <div className="anthropometry-detailed-progress__card__header">
        <div>
          <h2>Evolução mês a mês</h2>
          <p>Última visita registrada em cada mês</p>
        </div>
      </div>

      <div className="anthropometry-detailed-progress__monthly-wrapper">
        <table className="anthropometry-detailed-progress__monthly-table">
          <thead>
            <tr>
              <th>Métrica</th>
              {snapshot.months.map((month) => (
                <th key={month.key}>{month.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {snapshot.rows.map((row) => (
              <tr key={row.key}>
                <td className="anthropometry-detailed-progress__monthly-table__metric">
                  {row.label}
                </td>
                {row.cells.map((cell) => (
                  <td key={`${row.key}-${cell.monthKey}`}>{cell.valueLabel}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ProgressMonthlySection;
